"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphText = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ParagraphText = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("rect", { width: "24", height: "5", y: "2", fill: "currentColor", rx: "2.5" }),
    react_1.default.createElement("rect", { width: "24", height: "5", y: "10", fill: "currentColor", rx: "2.5" }),
    react_1.default.createElement("rect", { width: "15", height: "5", y: "18", fill: "currentColor", opacity: "0.65", rx: "2.5" }))); };
exports.ParagraphText = ParagraphText;
//# sourceMappingURL=paragraph-text.js.map